import AntLayout from 'antd/lib/layout';
import { useFela } from 'react-fela';

import { childrenPropType } from 'config/childrenPropType';

import Header from '../../containers/Header';

import Menu from '../Menu';

import rule from './Layout.rule';

const { Content, Sider } = AntLayout;

const Layout = ({ children }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <AntLayout>
                <Header />
                <AntLayout hasSider>
                    <Sider>
                        <Menu />
                    </Sider>
                    <Content>{children}</Content>
                </AntLayout>
            </AntLayout>
        </div>
    );
};

Layout.propTypes = {
    children: childrenPropType.isRequired,
};

export default Layout;
